import axios from "axios";
import Cognito from "../utility/CognitoAuth";
import CookieService from "./CookieService";
import { ACCOUNTS_CDK_URL } from "../config";
// gulp will replace the following when necessary
// const base_accounts_cdk_api = 'https://60171yaac5.execute-api.us-east-1.amazonaws.com/prod';
// The following line ends with "=" or else gulp will replace it and in this case we don't want that to happen.
const base_api =
  `${ACCOUNTS_CDK_URL}/ticketingintegration`;
  // `${base_accounts_cdk_api}/ticketingintegration`;
  // process.env.REACT_APP_YETI_API ||
  // "https://88cn5hx1mb.execute-api.us-east-1.amazonaws.com/prod/ticketingintegration";

async function defaultRequest() {
  const idToken = await Cognito.getIdToken();
  let req = axios.create({
    baseURL: base_api,
    headers: { Authorization: idToken },
  });

  return req;
}

const TicketService = {
  getTickets: async function (page = 1, pageSize = 10, filters = {}) {
    // base API URL

    const orgId = CookieService.getCookie("OrganizationId");
    const baseUrl = `${base_api}/tickets/${orgId}`;

    // construct the query string using the passed parameters
    const queryParams = {
      page,
      pageSize,
      filter: JSON.stringify(filters),
      internal_use: false,
    };

    const queryString = new URLSearchParams(queryParams).toString();
    const req = await defaultRequest();
    return req.get(`${baseUrl}?${queryString}`);
  }
};

export default TicketService;
